import service from "@/store/services/weekly-reports-service";

export const state = () => ({
  list: {},
  weeklyReport: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, weeklyReport) => {
    state.weeklyReport = weeklyReport;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((weeklyReport) => {
      commit("SET_RESOURCE", weeklyReport);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((weeklyReport) => {
      commit("SET_RESOURCE", weeklyReport);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((weeklyReport) => {
      commit("SET_RESOURCE", weeklyReport);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  refresh({ commit, dispatch }, params) {
    return service.refresh(params, this.$axios);
  },

  applyConfiguration({ commit, dispatch }, params) {
    return service.applyConfiguration(params, this.$axios).then((data) => {
      commit("SET_RESOURCE", data);
      return data;
    });
  },

  // Add the new downloadZip action
  downloadZip({ commit, dispatch }, params) {
    return service.downloadZip(params);
  },

  validate({ commit }, params) {
    return service.validate(params).then((weeklyReport) => {
      commit("SET_RESOURCE", weeklyReport);
    });
  },

  revertToDraft({ commit }, params) {
    return service.revertToDraft(params).then((weeklyReport) => {
      commit("SET_RESOURCE", weeklyReport);
    });
  },

  openItemsCheck(_, id) {
    return service.openItemsCheck(id);
  },
  internalInvoiceProducts(_, id) {
    return service.internalInvoiceProducts(id);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  weeklyReport: (state) => state.weeklyReport,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((weeklyReport) => ({
      id: weeklyReport.id,
    }));
  },
};

const weeklyReports = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default weeklyReports;
